import { call } from '../@';

const confirmPropertyTitleSelection = async (id: string) => call('property-confirmTitleSelection', { propertyId: id });

export default confirmPropertyTitleSelection;
